import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiFetch } from "../../utils/api";
import { useIsMobile } from "../../hooks/useIsMobile";
import { usePageTitle } from "../../hooks/usePageTitle";
import { AppHeader } from "../../components/AppHeader";
import { AppFooter } from "../../components/AppFooter";

const NDA_TEXT = `\u00A0\u00A0\u00A0\u00A0\uBCF8 \uB3D9\uC758\uC11C\uB294 LandTrust \uD50C\uB7AB\uD3FC\uC5D0\uC11C \uC81C\uACF5\uD558\uB294 \uBE44\uACF5\uAC1C \uB9E4\uBB3C \uC815\uBCF4\uC758 \uC5F4\uB78C \uBC0F \uBE44\uBC00\uC720\uC9C0\uC5D0 \uAD00\uD55C \uC0AC\uD56D\uC744 \uADDC\uC815\uD569\uB2C8\uB2E4.

\uC81C1\uC870 (\uBAA9\uC801)
\uBCF8 \uB3D9\uC758\uC11C\uB294 \uC5F4\uB78C\uC790\uAC00 LandTrust\uB97C \uD1B5\uD574 \uC811\uADFC\uD558\uB294 \uBE44\uACF5\uAC1C \uB9E4\uBB3C \uC815\uBCF4\uC758 \uBCF4\uD638\uC640 \uC801\uC808\uD55C \uC774\uC6A9\uC744 \uBCF4\uC7A5\uD558\uAE30 \uC704\uD574 \uCCB4\uACB0\uB429\uB2C8\uB2E4.

\uC81C2\uC870 (\uBE44\uBC00\uC720\uC9C0 \uC758\uBB34)
\uC5F4\uB78C\uC790\uB294 LandTrust\uB97C \uD1B5\uD574 \uCDE8\uB4DD\uD55C \uBE44\uACF5\uAC1C \uC815\uBCF4\uB97C \uC81C3\uC790\uC5D0\uAC8C \uB204\uC124, \uACF5\uAC1C, \uB610\uB294 \uC720\uCD9C\uD558\uC5EC\uC11C\uB294 \uC544\uB2C8 \uB429\uB2C8\uB2E4. \uC774\uB294 \uAD6C\uB450, \uBB38\uC11C, \uC804\uC790\uC801 \uBC29\uBC95 \uB4F1 \uBAA8\uB4E0 \uD615\uD0DC\uB97C \uD3EC\uD568\uD569\uB2C8\uB2E4.

\uC81C3\uC870 (\uBE44\uACF5\uAC1C \uC815\uBCF4\uC758 \uBC94\uC704)
\uBE44\uACF5\uAC1C \uC815\uBCF4\uB780 \uB2E4\uC74C\uC744 \uD3EC\uD568\uD569\uB2C8\uB2E4:
  \u2022 \uB9E4\uBB3C\uC758 \uC815\uD655\uD55C \uC18C\uC7AC\uC9C0 (\uC9C0\uBC88, \uC88C\uD45C)
  \u2022 \uC18C\uC720\uC790 \uC5F0\uB77D\uCC98 \uBC0F \uAC1C\uC778\uC815\uBCF4
  \u2022 \uB9E4\uB9E4 \uC870\uAC74 \uC138\uBD80\uC0AC\uD56D
  \u2022 \uC911\uAC1C\uC0AC\uAC00 \uBE44\uACF5\uAC1C\uB85C \uC9C0\uC815\uD55C \uAE30\uD0C0 \uC815\uBCF4

\uC81C4\uC870 (\uC815\uBCF4 \uC774\uC6A9 \uC81C\uD55C)
1. \uC5F4\uB78C\uC790\uB294 \uBE44\uACF5\uAC1C \uC815\uBCF4\uB97C \uB9E4\uBB3C \uAC80\uD1A0 \uBC0F \uAC70\uB798 \uBAA9\uC801\uC73C\uB85C\uB9CC \uC774\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.
2. \uBE44\uACF5\uAC1C \uC815\uBCF4\uB97C \uC774\uC6A9\uD55C \uBB34\uB2E8 \uC811\uCD09, \uC9C1\uAC70\uB798 \uC2DC\uB3C4, \uD0C0 \uD50C\uB7AB\uD3FC \uAC8C\uC2DC \uB4F1\uC744 \uAE08\uC9C0\uD569\uB2C8\uB2E4.
3. \uC5F4\uB78C\uD55C \uC815\uBCF4\uB97C \uCEA1\uCC98, \uBCF5\uC0AC, \uC800\uC7A5\uD558\uC5EC \uC678\uBD80\uC5D0 \uACF5\uC720\uD558\uB294 \uD589\uC704\uB97C \uAE08\uC9C0\uD569\uB2C8\uB2E4.

\uC81C5\uC870 (\uC190\uD574\uBC30\uC0C1)
\uC5F4\uB78C\uC790\uAC00 \uBCF8 \uB3D9\uC758\uC11C\uB97C \uC704\uBC18\uD558\uC5EC \uC815\uBCF4\uB97C \uC720\uCD9C\uD558\uAC70\uB098 \uBD80\uC815 \uC774\uC6A9\uD55C \uACBD\uC6B0, \uC774\uB85C \uC778\uD574 \uBC1C\uC0DD\uD558\uB294 \uBAA8\uB4E0 \uC190\uD574\uC5D0 \uB300\uD574 \uBC95\uC801 \uCC45\uC784\uC744 \uBD80\uB2F4\uD569\uB2C8\uB2E4. \uC774\uC5D0\uB294 \uC815\uBCF4 \uC81C\uACF5\uC790(\uC911\uAC1C\uC0AC) \uBC0F \uD50C\uB7AB\uD3FC\uC5D0 \uB300\uD55C \uC190\uD574\uBC30\uC0C1\uC774 \uD3EC\uD568\uB429\uB2C8\uB2E4.

\uC81C6\uC870 (\uC720\uD6A8\uAE30\uAC04)
\uBCF8 \uB3D9\uC758\uC11C\uB294 \uB3D9\uC758\uC77C\uB85C\uBD80\uD130 1\uB144\uAC04 \uC720\uD6A8\uD558\uBA70, \uAE30\uAC04 \uB9CC\uB8CC \uD6C4\uC5D0\uB3C4 \uC774\uBBF8 \uC5F4\uB78C\uD55C \uC815\uBCF4\uC5D0 \uB300\uD55C \uBE44\uBC00\uC720\uC9C0 \uC758\uBB34\uB294 \uC9C0\uC18D\uB429\uB2C8\uB2E4.

\uC81C7\uC870 (\uB3D9\uC758 \uCCA0\uD68C)
\uC5F4\uB78C\uC790\uB294 \uC5B8\uC81C\uB4E0\uC9C0 \uB3D9\uC758\uB97C \uCCA0\uD68C\uD560 \uC218 \uC788\uC73C\uBA70, \uCCA0\uD68C \uC2DC \uBE44\uACF5\uAC1C \uC815\uBCF4\uC5D0 \uB300\uD55C \uC811\uADFC \uAD8C\uD55C\uC774 \uC989\uC2DC \uC911\uB2E8\uB429\uB2C8\uB2E4. \uB2E8, \uCCA0\uD68C \uC774\uC804\uC5D0 \uC5F4\uB78C\uD55C \uC815\uBCF4\uC5D0 \uB300\uD55C \uBE44\uBC00\uC720\uC9C0 \uC758\uBB34\uB294 \uC720\uC9C0\uB429\uB2C8\uB2E4.`;

export function NdaAgreementPage() {
  usePageTitle("NDA \uB3D9\uC758");
  const navigate = useNavigate();
  const m = useIsMobile();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") || "/listings";

  const [agreed, setAgreed] = useState(false);
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const canSubmit = agreed && name.trim().length >= 2 && !submitting;

  async function handleSubmit() {
    if (!canSubmit) return;
    setSubmitting(true);
    setError("");
    try {
      await apiFetch("/api/nda/agree", {
        method: "POST",
        body: JSON.stringify({ name: name.trim() }),
      });
      navigate(redirect);
    } catch (e: any) {
      setError(e.message || "동의 처리 중 오류가 발생했습니다");
    } finally {
      setSubmitting(false);
    }
  }

  const st = styles(m);

  return (
    <div style={st.page}>
      <AppHeader backTo="_back" backLabel="← 뒤로" />

      <div style={st.content}>
        <div style={st.card}>
          <div style={st.titleWrap}>
            <div style={st.lockIcon}>{"\uD83D\uDD12"}</div>
            <h1 style={st.title}>{"\uBE44\uACF5\uAC1C \uB9E4\uBB3C \uC815\uBCF4 \uC5F4\uB78C \uB3D9\uC758\uC11C"}</h1>
            <p style={st.subtitle}>Non-Disclosure Agreement</p>
          </div>

          {/* 서명 즉시 열람 안내 박스 */}
          <div style={{
            background: "rgba(212,168,83,0.06)",
            border: "1px solid rgba(212,168,83,0.22)",
            borderLeft: "3px solid #D4A853",
            borderRadius: "var(--radius-md)",
            padding: m ? "16px" : "20px 24px",
            marginBottom: m ? 16 : 20,
          }}>
            <p style={{ margin: "0 0 12px", fontSize: m ? 13 : 14, fontWeight: 700, color: "#D4A853", letterSpacing: "0.3px" }}>
              {"\uD83D\uDD13"} 서명 즉시 열람됩니다
            </p>
            <div style={{ display: "flex", flexDirection: "column" as const, gap: 8 }}>
              {[
                "350건 매물의 실제 위치",
                "정확한 호가 및 면적",
                "소유자 정보 및 연락처",
                "법적 보호 하에 안전한 거래",
              ].map(item => (
                <div key={item} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ color: "#22C55E", fontSize: 14, flexShrink: 0 }}>{"\u2705"}</span>
                  <span style={{ fontSize: m ? 13 : 14, color: "#CBD5E1" }}>{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div style={st.docBox}>
            <pre style={st.docText}>{NDA_TEXT}</pre>
          </div>

          <label style={st.checkLabel}>
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              style={st.checkbox}
            />
            <span>{"\uC704 \uB0B4\uC6A9\uC744 \uBAA8\uB450 \uC77D\uACE0 \uB3D9\uC758\uD569\uB2C8\uB2E4"}</span>
          </label>

          <div style={st.nameRow}>
            <label style={st.nameLabel}>{"\uC11C\uBA85 (\uC2E4\uBA85)"}</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={"\uC2E4\uBA85\uC744 \uC785\uB825\uD558\uC138\uC694"}
              style={st.nameInput}
              disabled={!agreed}
            />
          </div>

          {error && <p style={st.error}>{error}</p>}

          <button
            onClick={handleSubmit}
            disabled={!canSubmit}
            style={canSubmit ? st.submitBtn : st.submitBtnDisabled}
          >
            {submitting ? "\uCC98\uB9AC \uC911..." : "\uB3D9\uC758\uD558\uACE0 \uC5F4\uB78C \uAD8C\uD55C \uBC1B\uAE30"}
          </button>

          <p style={st.note}>{"\uB3D9\uC758 \uD6C4 \uBE44\uACF5\uAC1C \uB9E4\uBB3C\uC758 \uC815\uD655\uD55C \uC704\uCE58, \uC9C0\uBC88, \uC18C\uC720\uC790 \uC815\uBCF4\uB97C \uC5F4\uB78C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."}</p>
        </div>
      </div>
      <AppFooter />
    </div>
  );
}

function styles(m: boolean): Record<string, React.CSSProperties> {
  return {
    page: {
      minHeight: "100vh",
      background: "var(--bg-primary)",
    },
    header: { background: "var(--bg-card)", borderBottom: "1px solid var(--border-light)", position: "sticky", top: 0, zIndex: 100 },
    headerInner: { maxWidth: 1100, margin: "0 auto", padding: m ? "0 12px" : "0 20px", height: m ? 48 : 56, display: "flex", alignItems: "center", justifyContent: "space-between" },
    headerBack: { background: "none", border: "none", color: "var(--text-secondary)", fontSize: m ? 13 : 14, cursor: "pointer", fontWeight: 500 },
    logo: { fontSize: m ? 16 : 18, fontWeight: 800, color: "var(--lt-gold)", letterSpacing: "-0.5px" },
    content: {
      maxWidth: 960,
      margin: "0 auto",
      padding: m ? "20px 16px 40px" : "36px 32px 56px",
      background: "radial-gradient(ellipse at 50% -5%, rgba(212,168,83,0.06) 0%, transparent 60%)",
    },
    card: {
      background: "var(--bg-card)",
      border: "1px solid var(--border-gold, rgba(212,168,83,0.2))",
      borderTop: "2px solid var(--lt-gold)",
      borderRadius: "var(--radius-xl)",
      padding: m ? "28px 20px" : "44px 48px",
      boxShadow: "var(--shadow-xl)",
    },
    titleWrap: {
      textAlign: "center" as const,
      marginBottom: m ? 20 : 28,
      paddingBottom: m ? 16 : 20,
      borderBottom: "1px solid var(--border-light)",
    },
    lockIcon: {
      fontSize: m ? 32 : 44,
      marginBottom: 12,
      filter: "drop-shadow(0 0 12px rgba(212,168,83,0.4))",
    },
    title: {
      fontSize: m ? 18 : 24,
      fontWeight: 800,
      color: "var(--text-primary)",
      margin: "0 0 6px",
      letterSpacing: "-0.3px",
    },
    subtitle: {
      fontSize: m ? 13 : 14,
      color: "var(--lt-gold)",
      margin: 0,
      fontStyle: "italic" as const,
      letterSpacing: "0.5px",
    },
    docBox: {
      maxHeight: m ? 260 : 380,
      overflowY: "auto" as const,
      border: "1px solid var(--border-medium)",
      borderRadius: "var(--radius-md)",
      padding: m ? "16px" : "20px 24px",
      marginBottom: m ? 16 : 20,
      background: "rgba(0,0,0,0.2)",
    },
    docText: {
      fontSize: m ? 13 : 14,
      lineHeight: 1.9,
      color: "#CBD5E1",
      margin: 0,
      whiteSpace: "pre-wrap" as const,
      fontFamily: "inherit",
    },
    checkLabel: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      fontSize: m ? 14 : 15,
      fontWeight: 600,
      color: "var(--text-primary)",
      cursor: "pointer",
      marginBottom: 16,
      padding: "14px 0",
      borderTop: "1px solid var(--border-light)",
    },
    checkbox: { width: 20, height: 20, accentColor: "var(--lt-gold)", cursor: "pointer", flexShrink: 0 },
    nameRow: { marginBottom: 16 },
    nameLabel: {
      display: "block",
      fontSize: 12,
      fontWeight: 700,
      color: "var(--text-muted)",
      marginBottom: 8,
      letterSpacing: "0.6px",
      textTransform: "uppercase" as const,
    },
    nameInput: {
      width: "100%",
      padding: "12px 14px",
      borderRadius: "var(--radius-md)",
      border: "1px solid var(--border-medium)",
      background: "var(--bg-secondary)",
      color: "var(--text-primary)",
      fontSize: 16,
      boxSizing: "border-box" as const,
    },
    error: {
      color: "var(--lt-red)",
      fontSize: 13,
      marginBottom: 12,
      padding: "8px 12px",
      background: "rgba(239,68,68,0.08)",
      borderRadius: "var(--radius-md)",
    },
    submitBtn: {
      width: "100%",
      padding: "15px 0",
      borderRadius: "var(--radius-md)",
      border: "none",
      background: "linear-gradient(135deg, #B8972E, #D4AF37)",
      color: "#0F172A",
      fontSize: 16,
      fontWeight: 700,
      cursor: "pointer",
      marginBottom: 14,
      letterSpacing: "0.3px",
    },
    submitBtnDisabled: {
      width: "100%",
      padding: "15px 0",
      borderRadius: "var(--radius-md)",
      border: "1px solid var(--border-light)",
      background: "transparent",
      color: "var(--text-muted)",
      fontSize: 16,
      fontWeight: 700,
      cursor: "not-allowed",
      marginBottom: 14,
    },
    note: {
      fontSize: m ? 13 : 14,
      color: "#CBD5E1",
      textAlign: "center" as const,
      margin: 0,
      lineHeight: 1.6,
    },
  };
}
